<template>
  <div class="card">
    <b-field>
      <b-input
        :placeholder="$t('evenement.chercher_evenement')"
        @input="search()"
        type="search"
        icon="magnify"
        v-model="search_query"
      ></b-input>
    </b-field>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  computed: {
    search_query: {
      get: function() {
        return this.$store.state.evenement.search_query;
      },
      set: function(newValue) {
        this.$store.commit(`UPDATE_SEARCH_QUERY_INPUT`, newValue);
      }
    }
  },
  methods: {
    search() {
      this.$store.commit("SEARCH", this.search_query);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/event/components/SearchBar.vue